import React from 'react'
import '../styles/services.css'
import ServicesComp from '../components/services_component'


function Areas() {
    return (
        <div className='text-center'>
            <div className='zoom-services d-flex justify-content-center align-items-center flex-column'>
                <div className='zoom-bg-services'></div>
                <div>
                    <span className='zoom-span-services'>ÁREAS DE</span>
                    <span className='zoom-span-services fw-bold'>PRACTICA</span>
                </div>
            </div>
            <ServicesComp />
        </div>
    )
}

export default Areas
